<script>
  import Input from "./Input.svelte";
  import IconTitle from "./IconTitle.svelte";
  import {
    currentScenario,
    reportCopy,
    getCopyId,
  } from "../../stores/currentSelections";

  const title = getCopyId($reportCopy, "calculator-inputs-title");
</script>

<div class="px-4 ">
  <IconTitle
    {title}
    name="hand-point-down-Light"
    fill="#F8BC2C"
    size={30}
    mb={4}
  />

  <div class="grid grid-cols-1 gap-4 mb-8 md:grid-cols-2">
    <Input input="currentAge" type="years" />
    <Input input="currentYearsOfService" type="years" />
    {#if $currentScenario === 5}
      <Input input="ageAtRetirement" type="years" />
    {/if}
    <Input input="currentFinalAverageSalary" type="$" />
  </div>
</div>
